import { useMediaQuery } from "./useMediaQuery";

export function useIsMobile() {
  const isGTMobile = useMediaQuery("md");

  return !isGTMobile;
}
